module.exports = __webpack_public_path__ + "img/basedata_grey.c169199a.svg";